export default {
  "footer.events.header": "Events",
  "footer.events.event.subheader": "Events",
  "footer.events.event.main": "LINK-J Events/LINK-J Supported Events",
  "footer.events.event.coSponsorship": "Co-sponsorship",
  "footer.events.event.memberEvent": "Special Member Events",
  "footer.events.event.archive": "Past Events",
  "footer.events.report.subheader": "Event Reports",
  "footer.events.report.main": "LINK-J Events/LINK-J Supported Events",
  "footer.events.report.memberEvent": "Special Member Events",
  "footer.events.report.coSponsorship": "Co-sponsorship",
  "footer.events.report.attend": "Exhibitions",
  "footer.program.header": "Programs",
  "footer.program.consultation": "Out of Box Consulting Room",
  "footer.program.program": "Training Programs",
  "footer.interviews.header": "Interviews & Blogs",
  "footer.interviews.interview.subheader": "Interviews & Blogs",
  "footer.interviews.interview.article": "スペシャルインタビュー",
  "footer.interviews.interview.supporter": "LINK-J News Letter", // previously "Supporter Interviews"
  "footer.interviews.interview.column": "What’s in Nihonbashi",
  "footer.interviews.interview.staff": "LINK-J Staff Blog",
  "footer.interviews.interview.series": "連載コラム",
  "footer.interviews.interview.startUpInterviews": "Start-up Interviews",
  "footer.interviews.interview.research": "Researcher Interviews",
  "footer.news.header": "News",
  "footer.news.news.subheader": "News",
  "footer.news.news.topics": "Topics",
  "footer.news.news.pressRelease": "Press Releases",
  "footer.news.news.media": "LINK-J in the News",
  "footer.news.news.overseas": "News from overseas",
  "footer.news.news.program": "Training Programs",
  "footer.news.news.events": "Events",
  "footer.about.header": "About us",
  "footer.about.greetings": "Message from the Chairman of the Board",
  "footer.about.why": "Why in Nihonbashi",
  "footer.about.west": "What’s LINK-J WEST",
  "footer.about.overseas": "Overseas Collaborations",
  "footer.about.message": "Messages of Support",
  "footer.about.supporter": "Supporters",
  "footer.about.business.company": "Our Activities",
  "footer.about.business.organiation": "Organization",
  "footer.about.membership.subscription.pamphlet": "Brochure",
  "footer.about.membership.subscription.gtb": "Greater Tokyo Biocommunity",
  "footer.membership.header": "Special Members",
  "footer.membership.introduction": "List of Special Members",
  "footer.membership.existing": "About Special Members",
  "footer.membership.subscription": "Membership Application",
  "footer.facilities.header": "Facilities",
  "footer.facilities.room": "Lounges and Conference rooms",
  "footer.facilities.office": "Offices and Laboratory",
  "footer.facilities.access": "Access",
  "footer.contact": "Contact us",
  "footer.youtube.link.title": "YouTube Channel",
  "footer.youtube.img.alt": "YouTube",
  "footer.newsletter": "Subscribe to LINK-J Event News",
  "footer.bbt": "Blockbuster TOKYO",
  "footer.lifeScience.link.title": "Life Science Building Series",
  "footer.lifeScience.img.alt": "lifescience",
  "footer.mitsuiLinkLab.link.title": "Mitsui Link-Lab",
  "footer.mitsuiLinkLab.img.alt": "Mitsui Link-Lab",
  "footer.links.logo": "Life Science Innovation Network Japan",
  "footer.links.list.faq": "FAQ",
  "footer.links.list.access": "Access",
  "footer.links.list.termsAndConditions": "Terms and Conditions",
  "footer.links.list.logoGuidelines": "Logo Guidelines",
  "footer.links.list.privacy": "Personal Information ProtectionPolicy",
  "footer.links.list.use": "Handling of Personal Information",
  "footer.copyright": "© Life Science Innovation Network Japan",

  "footer.events.event.attend": "",
  "footer.program.sandbox": "",
  "footer.program.unikorn": "",
  "footer.program.linkBiobay": `What's "LINK-BioBAY TOKYO"？`,
  "footer.interviews.interview.supporterColumn": "",
  "footer.news.news.sponsorship": "",
  "footer.news.bulletinboard.subheader": "The Shared Bulletin Board",
  "footer.membership.menu": "",
  "footer.links.list.help": "",
  "footer.links.list.adGuide": "",
  "footer.links.list.tradeLaw": "",
} as const;
